import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const FormEditService = () => {
  const [ticket_id, setTicketId] = useState("");
  const [service_id, setServiceId] = useState("");
  const [description, setDesc] = useState("");
  const [technician, setTechnician] = useState("");
  const [product_name, setProductName] = useState("");
  const [serialnumber, setSerialNumber] = useState("");
  const [url, setUrl] = useState("");
  const [repair_status, setRepairStatus] = useState("");
  const [clientName, setClientName] = useState("");
  const [start_time, setStartTime] = useState("");
  const [end_time, setEndTime] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;
   
  const handleEndTimeChange = (event) => {
    setEndTime(event.target.value);
  };
  const handleStartTimeChange = (event) => {
    setStartTime(event.target.value);
  };
  
  useEffect(() => {
    const getServiceById = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/services/${id}`, {
          headers: {
            'X-API-Key': API_KEY
          },
        });

        setTicketId(response.data.ticket.ticket_id);
        setDesc(response.data.description);
        setRepairStatus(response.data.repair_status);        
        setServiceId(response.data.service_id);
        setTechnician(response.data.technician);
        setProductName(response.data.ticket.product.name);
        setSerialNumber(response.data.ticket.product.serialnumber);
        setManufacturer(response.data.ticket.product.manufacturer);
        setUrl(response.data.ticket.product.url);
        setClientName(response.data.contract.client.name);

        if(response.data.repair_status==="RECEIVED" || response.data.repair_status==="IN PROGRESS" || response.data.repair_status==="COMPLETED" || response.data.repair_status==="RETURNED" || response.data.repair_status==="CLOSED"){
          const startdate = new Date(response.data.start_time);
          startdate.setMinutes(startdate.getMinutes() - startdate.getTimezoneOffset());
          const starttime = startdate.toISOString().slice(0,16);
          setStartTime(starttime);
        }

        if(response.data.repair_status==="CLOSED"){
          const enddate = new Date(response.data.end_time);
          enddate.setMinutes(enddate.getMinutes() - enddate.getTimezoneOffset());
          const endtime = enddate.toISOString().slice(0,16);
          setEndTime(endtime);
        }


      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };
    getServiceById();
  }, [id]);

  const updateService = async (e) => {
    e.preventDefault();
    try {
      await axios.patch(`${API_BASE_URL}/services/${id}`, {
        headers: {
            'X-API-Key': API_KEY
        },
        repair_status: repair_status,
        start_time: start_time,
        end_time: end_time,
        technician: technician,
      });
      navigate("/services");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };
  
  return (
    <div className="panel is-link">
      <p className="panel-heading">UPDATE SERVICE REPAIR</p>
      <div className="card is-shadowless p-2">
        <h1 className="title is-size-5 mt-4">Product Info:</h1>
        <table className="table is-bordered is-striped is-fullwidth is-size-7">
            <thead>
                <tr>
                  <th style={{width: "1%"}}>No</th>
                  <th className="has-text-centered">Image</th>
                  <th className="has-text-centered">Product</th>  
                  <th className="has-text-centered">Serial_Number</th>  
                  <th className="has-text-centered">Merek/Manufacturer</th>        
                  <th className="has-text-centered">Problem_Description</th>                  
                </tr>
            </thead>
            <tbody>              
                <tr>
                    <td>{1}</td>
                    <td>
                      <figure className="image is-4by3">
                        <img src={url} alt="Image" />
                      </figure>
                    </td>
                    <td>{product_name}</td>  
                    <td className="has-text-centered">{serialnumber}</td>  
                    <td>{manufacturer}</td>
                    <td>{description}</td>        
                </tr>            
            </tbody>
        </table> 
        <form onSubmit={updateService}>
          <p className="has-text-left has-text-danger">{msg}</p>
          <div className="field columns">
            <div className="column is-3">
              <label className="label">Service_Id</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={service_id}
                  onChange={(e) => setServiceId(e.target.value)}
                  disabled
                />
              </div>
            </div>
            <div className="column is-3">
              <label className="label">Ticket_Id</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={ticket_id}
                  onChange={(e) => setTicketId(e.target.value)}
                  disabled
                />
              </div>
            </div>  
            <div className="column is-6">
                <label className="label">Client/Customer</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                    disabled
                  />
                </div>     
            </div>  
          </div>
          <div className="field columns">
            <div className="column is-3">
                <label className="label">Repair_Status</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      value={repair_status}
                      onChange={(e) => setRepairStatus(e.target.value)}
                    >
                      <option value="OPEN">OPEN</option>
                      <option value="RECEIVED">RECEIVED</option>
                      <option value="IN PROGRESS">IN PROGRESS</option>
                      <option value="COMPLETED">COMPLETED</option>
                      <option value="RETURNED">RETURNED</option>
                      <option value="CLOSED">CLOSED</option>
                    </select>
                  </div>
                </div>
            </div>
            {repair_status==="RECEIVED" ? (
            <div className="column is-3">
              <label className="label">Start_Time</label>
              <div className="control">
                  <input className="input"
                    type="datetime-local"
                    id="start_time"
                    name="star_time"
                    value={start_time} // Controlled component
                    onChange={handleStartTimeChange}/>
              </div>
            </div> 
            ) : repair_status==="CLOSED" || repair_status==="COMPLETED" || repair_status==="IN PROGRESS" || repair_status==="RETURNED" ? (
                 <div className="column is-3">
                  <label className="label">Start_Time</label>
                  <div className="control">
                      <input className="input"
                        type="datetime-local"
                        id="start_time"
                        name="star_time"
                        value={start_time} // Controlled component
                        disabled/>
                  </div>
                </div> 
            ) : (
              <p></p>
            )}  
            {repair_status==="CLOSED" ? (
                <div className="column is-3">
                  <label className="label">End_Time</label>
                  <div className="control">
                    <input className="input"
                        type="datetime-local"
                        id="end_time"
                        name="end_time"
                        value={end_time} // Controlled component
                        onChange={handleEndTimeChange}
                    />
                  </div>
                </div>
                ) : (
                  <p></p>
                )}  
            <div className="column is-3">
              <label className="label">Technician</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={technician}
                  onChange={(e) => setTechnician(e.target.value)}
                />
              </div>     
            </div>
          </div>
         
          <div className="field">
              <Link to="/services">
              <button className="button is-warning mr-1">
                  Cancel
              </button>
              </Link>
              <button type="submit" className="button is-success">
                  Update
              </button>
          </div>          
      </form>               
    </div>
  </div>
  );
};

export default FormEditService;